/* PAPAPATTES — filtre : pastilles de type sur 2 lignes max ("… plus"), croix de fermeture.
   Aucune dépendance. Les pastilles sont ré-injectées par Dawn (facets.js) après chaque filtrage :
   on observe #PPTypeChips et on recalcule la mise en page. */
(function () {
  var MAX_ROWS = 2;
  var level = 1;            // palier courant (1..steps) ; au-delà = tout affiché

  function rows(items) {
    var tops = [];
    items.forEach(function (li) {
      if (li.hidden) return;
      var t = li.offsetTop;
      if (!tops.some(function (x) { return Math.abs(x - t) < 3; })) tops.push(t);
    });
    return tops.sort(function (a, b) { return a - b; });
  }

  // Facettes additionnées en tête, la dernière ajoutée en premier (ordre des paramètres de l'URL).
  // PC : à partir de 2 actives (has-multi) ; mobile : dès la 1re facette ajoutée.
  function orderActive(ul) {
    var lis = [].slice.call(ul.querySelectorAll('li'));
    lis.forEach(function (li) { li.style.removeProperty('order'); });
    var mobile = window.matchMedia('(max-width: 989px)').matches;
    if (!mobile && !ul.classList.contains('has-multi')) return;
    var vals = new URLSearchParams(location.search).getAll('filter.p.m.custom.type_produit');
    lis.forEach(function (li) {
      var a = li.querySelector('.pp-chip-solo');
      if (!a || !li.querySelector('.pp-type-group.is-active')) return;
      var i = vals.indexOf(a.getAttribute('data-solo-value'));
      if (i > -1) li.style.setProperty('order', String(-1000 - i), 'important');
    });
  }

  function layout() {
    var ul = document.querySelector('#PPTypeChips .pp-type-chips');
    if (!ul) return;
    orderActive(ul);
    var more = ul.querySelector('.pp-more:not(.pp-less)');
    if (!more) return;
    var btn = more.querySelector('button');
    var less = ul.querySelector('.pp-less');
    if (!less) {                                        // bouton « … moins » : clone de « … plus », ajouté après lui
      less = more.cloneNode(true);
      less.classList.add('pp-less');
      var lb = less.querySelector('button');
      lb.classList.add('pp-less__btn');
      lb.setAttribute('data-dir', 'less');
      lb.textContent = '… moins';
      more.parentNode.insertBefore(less, more.nextSibling);
    }
    var lessBtn = less.querySelector('button');
    var items = [].slice.call(ul.children).filter(function (li) { return !li.classList.contains('pp-more') && !li.classList.contains('pp-clear-li'); });
    items.forEach(function (li) { li.hidden = false; });
    more.hidden = true;
    less.hidden = true;
    ul.classList.remove('is-expanded');

    var tops = rows(items);
    if (tops.length <= MAX_ROWS) return;               // tout tient sur 2 lignes

    // Trop de pastilles : total arrondi à la dizaine sup., découpé en `steps` paliers égaux
    // (ex. 58 -> 60, 3 étapes -> 20 de plus à chaque clic). `steps` : réglage du thème (data-steps).
    var mount = document.getElementById('PPTypeChips');
    var steps = Math.max(1, parseInt(mount && mount.getAttribute('data-steps'), 10) || 3);
    var total = items.length;
    var step = Math.max(1, Math.ceil(Math.ceil(total / 10) * 10 / steps));
    // 1er affichage : seulement `initial` pastilles (réglage du thème, data-initial), puis +`step` à chaque clic.
    var initial = Math.max(1, parseInt(mount && mount.getAttribute('data-initial'), 10) || 5);
    var actives = items.filter(function (li) { return li.querySelector('.pp-type-group.is-active'); }).length;
    initial = Math.max(initial, actives);
    var maxLevel = Math.max(1, 1 + Math.ceil(Math.max(0, total - initial) / step));
    level = Math.min(Math.max(1, level), maxLevel);
    var shown = Math.min(total, initial + step * (level - 1));
    // actives d'abord (même ordre que l'affichage), puis ordre naturel
    var sorted = items.map(function (li, k) { return { li: li, k: k, o: parseInt(li.style.order, 10) || 0 }; })
      .sort(function (a, b) { return a.o - b.o || a.k - b.k; });
    items.forEach(function (li) { li.removeAttribute('data-extra'); });
    sorted.forEach(function (x, n) { x.li.hidden = n >= shown; });

    // « … plus » tant qu'il reste des pastilles ; « … moins » dès qu'on a dépassé le 1er palier (les deux au milieu)
    more.hidden = shown >= total;
    less.hidden = level <= 1;
    btn.setAttribute('aria-expanded', String(level > 1));
    lessBtn.setAttribute('aria-expanded', 'true');
    if (!more.hidden) btn.setAttribute('data-tip', 'Afficher ' + Math.min(step, total - shown) + ' types de plus');
    if (!less.hidden) lessBtn.setAttribute('data-tip', 'Afficher ' + (shown - Math.min(total, initial + step * (level - 2))) + ' types de moins');
  }

  // Affichage progressif : les pastilles ajoutées par le palier apparaissent une à une, « … moins » les replie.
  function stagger(list, reverse) {
    list.forEach(function (li, k) {
      var n = reverse ? list.length - 1 - k : k;
      li.style.animationDelay = (Math.min(n, 25) * 40) + 'ms';
    });
    return Math.min(list.length, 26) * 40 + 220;
  }
  function toggleMore(dir) {
    var ul = document.querySelector('#PPTypeChips .pp-type-chips');
    if (!ul) { level = 1; layout(); return; }
    var items = [].slice.call(ul.children).filter(function (li) { return !li.classList.contains('pp-more') && !li.classList.contains('pp-clear-li'); });
    var before = items.filter(function (li) { return !li.hidden; });
    level = Math.max(1, level + (dir === 'less' ? -1 : 1));
    layout();
    var after = items.filter(function (li) { return !li.hidden; });
    if (dir === 'less') {
      // pastilles qui viennent d'être repliées : on les ré-affiche le temps de l'animation de sortie
      var out = before.filter(function (li) { return after.indexOf(li) < 0; });
      out.forEach(function (li) { li.hidden = false; li.setAttribute('data-extra', '1'); });
      var d2 = stagger(out, true);
      ul.classList.add('is-hiding');
      setTimeout(function () {
        ul.classList.remove('is-hiding');
        out.forEach(function (li) { li.removeAttribute('data-extra'); });
        layout();
      }, d2);
    } else {
      var added = after.filter(function (li) { return before.indexOf(li) < 0; });
      added.forEach(function (li) { li.setAttribute('data-extra', '1'); });
      var d = stagger(added, false);
      ul.classList.add('is-revealing');
      setTimeout(function () { ul.classList.remove('is-revealing'); added.forEach(function (li) { li.removeAttribute('data-extra'); }); }, d + 80);
    }
  }

  // Évite le flash « tout s'affiche puis se réduit à 2 lignes » : les pastilles restent invisibles
  // (place réservée) tant que la mise en page n'est pas calculée, puis apparaissent d'un coup.
  function setReady(on) {
    var m = document.getElementById('PPTypeChips');
    if (m) m.classList.toggle('is-ready', on);
  }
  var loaded = document.readyState === 'complete';   // facettes cachées jusqu'à la fin du chargement de la page
  var timer;
  function schedule() {
    setReady(false);
    clearTimeout(timer);
    timer = setTimeout(function () {
      layout();
      if (loaded) setReady(true);
    }, 30);
  }

  // ■ "solo" : on retire toutes les valeurs de type déjà actives et on ne garde que celle-ci.
  // Phase de capture => l'href est réécrit avant que <facet-remove> (Dawn) ne le lise.
  document.addEventListener('click', function (e) {
    var solo = e.target.closest && e.target.closest('.pp-chip-solo');
    if (!solo || solo.getAttribute('data-keep-href')) return;
    if (window.matchMedia('(max-width: 989px)').matches) return;   // mobile : clic = ajout/retrait simple
    var url = new URL(solo.href, location.origin);
    url.searchParams.delete('filter.p.m.custom.type_produit');
    url.searchParams.append('filter.p.m.custom.type_produit', solo.getAttribute('data-solo-value'));
    solo.href = url.pathname + url.search;
  }, true);

  document.addEventListener('click', function (e) {
    var moreBtn = e.target.closest && e.target.closest('.pp-more__btn, .pp-less__btn');
    if (moreBtn) { toggleMore(moreBtn.getAttribute('data-dir')); return; }

    var close = e.target.closest && e.target.closest('.pp-facets-close');
    if (close) {
      // fermer = accepter : on valide la saisie en cours (ex. prix) puis on ferme comme "Appliquer"
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      var wrapper = close.closest('.mobile-facets__wrapper');
      var summary = wrapper && wrapper.querySelector('summary');
      if (summary) summary.click();
    }
  });

  // Dawn remplace tout #ProductGridContainer (donc #PPTypeChips lui-même) à chaque filtre :
  // on surveille le body pour ré-attacher l'observateur et recalculer "… plus / … moins".
  function observe() {
    var mount = document.getElementById('PPTypeChips');
    if (!mount || mount.__ppObserved) return;
    mount.__ppObserved = true;
    new MutationObserver(schedule).observe(mount, { childList: true, subtree: true });
    schedule();
  }
  new MutationObserver(function () {
    var mount = document.getElementById('PPTypeChips');
    if (mount && !mount.__ppObserved) observe();
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  function init() {
    observe(); layout();
    if (loaded) setReady(true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () {
    loaded = true;
    var done = function () { init(); layout(); setReady(true); };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(done); else done();
  });
  window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(layout, 60); });
})();
